StoreService.$inject = ['$resource', '$window', 'Alerts', '$q'];

function StoreService($resource, $window, Alerts, $q) {
    const Stores = $resource('api/stores/:id', null, {
        update: {
            method: 'PUT'
        }
    });

    const storage = $window.localStorage;

    let stores;
    let staleFlag = false;

    this.getStores = getStores;
    this.getStore = getStore;
    this.getCurrentStore = getCurrentStore;
    this.setStore = setStore;
    this.saveStore = saveStore;
    this.deleteStore = deleteStore;
    this.checkStoreIdTaken = checkStoreIdTaken;
    this.formatStoreName = formatStoreName;

    //storing state of stores list filters and sorts so remembered when going back into the page
    this.storesListState = {
        sortOrder: 'storeId',
        searchCriteria: ''
    };

    function getStores() {
        if (!stores || staleFlag) {
            stores = Stores.query().$promise.catch(() => staleFlag = true);
            staleFlag = false;
        }
        return stores;
    }

    function getStore(id) {
        if (id) {
            return getStoreById(id);
        } else {
            const deferred = $q.defer();
            let store = getCurrentStore();
            if (store && store.storeId) {
                deferred.resolve(store);
            } else {
                deferred.reject();
            }
            return deferred.promise;
        }
    }

    function getStoreById(id) {
        return Stores.get({
            id
        }).$promise;
    }

    function getCurrentStore() {
        return JSON.parse(storage.getItem('drm-store'));
    }

    function setStore(store) {
        if (store && store.storeId) {
            return storage.setItem('drm-store', JSON.stringify(store));
        }
    }

    function saveStore(store) {
        const method = store.id === 0 ? Stores.save : Stores.update;
        return method({}, store).$promise.then(() => {
            staleFlag = true;
        });
    }

    function deleteStore(id) {
        return Stores.delete({
            id: id
        }).$promise.then(() => {
            staleFlag = true;
        });
    }

    function checkStoreIdTaken(store) {
        return getStores().then(stores => {
            for (var index = 0; index < stores.length; index++) {
                //note: make sure we don't check against self
                if (stores[index].id != store.id && stores[index].storeId == store.storeId) {
                    return true;
                }
            }
            return false;
        });
    }

    function formatStoreName(store) {
        const id = String('0000' + store.storeId).slice(-4);
        return `${store.storeName} ( A${id} )`;
    }
}

export default StoreService;



// WEBPACK FOOTER //
// ./src/js/services/stores/index.js